// imports
import WCarousel from './WCarousel';

// class definition
export default class NewsCarousel extends WCarousel {
    // constructor
    constructor (args = {}, objectName = 'NewsCarousel') {
        args.debug = args.debug || false;

        args.settings = {
            spaceBetween: 0,
        };

        // super
        super(args, objectName);
    }

    // methods
    destroy () {
        // super destroy
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
